export default {
  'pages.setting.role.title': 'Role Management',
  'pages.setting.role.subtitle':
    'Manage system roles, permission configuration and access control',
  'pages.setting.role.searchPlaceholder':
    'Search role name, code or description',
  // Table columns
  'pages.setting.role.column.id': 'Role ID',
  'pages.setting.role.column.roleName': 'Role Name',
  'pages.setting.role.column.roleKey': 'Role Code',
  'pages.setting.role.column.description': 'Description',
  'pages.setting.role.column.userCount': 'Users',
  'pages.setting.role.column.permission': 'Permissions',
  'pages.setting.role.column.status': 'Status',
  'pages.setting.role.column.createTime': 'Created Time',
  'pages.setting.role.column.operation': 'Operation',
  // Status
  'pages.setting.role.status.enabled': 'Enabled',
  'pages.setting.role.status.disabled': 'Disabled',
  // Modal titles
  'pages.setting.role.modal.addTitle': 'Add Role',
  'pages.setting.role.modal.editTitle': 'Edit Role',
  'pages.setting.role.add': 'Add Role',
  'pages.setting.role.edit': 'Edit',
  // Form
  'pages.setting.role.form.roleName': 'Role Name',
  'pages.setting.role.form.roleNamePlaceholder': 'Please enter role name',
  'pages.setting.role.form.roleNameRequired': 'Please enter role name',
  'pages.setting.role.form.roleKey': 'Role Code',
  'pages.setting.role.form.roleKeyPlaceholder': 'e.g.: sales_manager',
  'pages.setting.role.form.roleKeyRequired': 'Please enter role code',
  'pages.setting.role.form.roleKeyPattern':
    'Role code can only contain letters, numbers and underscores, 2-20 characters',
  'pages.setting.role.form.roleKeyExists': 'Role code already exists',
  'pages.setting.role.form.description': 'Description',
  'pages.setting.role.form.descriptionPlaceholder':
    'Please enter role description',
  'pages.setting.role.form.status': 'Status',
  'pages.setting.role.form.statusPlaceholder': 'Please select status',
  'pages.setting.role.form.statusRequired': 'Please select status',
  'pages.setting.role.form.permission': 'Permission Configuration',
  'pages.setting.role.form.permissionRequired': 'Please configure permissions',
  'pages.setting.role.form.selectedCount': '{count} selected',
  'pages.setting.role.form.selectAll': 'Select All',
  'pages.setting.role.form.clear': 'Clear',
  // Messages
  'pages.setting.role.message.deleteSuccess': 'Deleted successfully',
  'pages.setting.role.message.addSuccess': 'Added successfully',
  'pages.setting.role.message.editSuccess': 'Updated successfully',
};
